import * as React from 'react';



export default function Fallback({messageData}) {
  return (
<div className="rw-response"><div className="rw-message-text"><div className="rw-markdown"><p>Sorry, something went wrong can you rephrase that?</p></div></div></div>

  );
}